module.exports = __webpack_public_path__ + "img/david-bushnell.4aa66cc9.png";